import { Power4, gsap } from "gsap";

export const suggestionsHitsAnimation = () => {
    const tl = gsap.timeline({
        defaults: {
            ease: Power4.easeInOut,
            duration: 0.5,
        },
    });

    tl.to(".suggestion-hit__container", {
        y: 0,
        opacity: 1,
    });
    return tl;
};
